module.exports = __webpack_public_path__ + "static/media/tindastollunknown.d4f1d7f2.svg";